import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Section, Eyebrow } from "@/components/PublicLayout";

export default function Leadership() {
  const [people, setPeople] = useState([]);
  useEffect(() => { api.get("/leadership").then((r) => setPeople(r.data)); }, []);
  return (
    <Section className="py-16 md:py-24">
      <Eyebrow>Leadership</Eyebrow>
      <h1 className="font-serif text-4xl md:text-6xl tracking-tight text-ink">Those responsible for Simo University</h1>
      <p className="mt-5 max-w-2xl text-ink/65 leading-relaxed">The scholars and leaders who set Simo University's direction and safeguard its academic standard.</p>
      <div className="mt-12 grid md:grid-cols-3 gap-px bg-border border border-border">
        {people.map((p) => (
          <div key={p.slug} data-testid={`leader-${p.slug}`} className="bg-paper p-8">
            <div className="h-20 w-20 rounded-full bg-heraldic/10 border border-heraldic/20 flex items-center justify-center font-serif text-2xl text-heraldic">
              {p.name.split(" ").filter(Boolean).slice(-2).map((n) => n[0]).join("")}
            </div>
            <div className="mt-4 font-serif text-2xl text-ink">{p.name}</div>
            <div className={`mt-1 text-sm ${p.approved ? "text-heraldic" : "text-ink/40 italic"}`}>{p.role}</div>
            {p.approved ? (
              <p className="mt-3 text-sm text-ink/60 leading-relaxed">{p.bio}</p>
            ) : (
              <p className="mt-3 text-xs text-ink/40" />
            )}
          </div>
        ))}
      </div>
    </Section>
  );
}
